export const ItemTypes = {
  ELEMENT: 'ELEMENT'
};



// WEBPACK FOOTER //
// ./src/commons/ItemTypes.js